import React, { useContext } from "react";

export interface IcaWebsocketContextType {
    user: any;
    setOnMessage: (data: any) => void;
    startStopTopic: (command: string, name: string, state: string, custom?: string) => void;
    disposeConnection: () => void;
    connectionState: boolean;
    sendMessage: (data: any) => void;
    initializeConnection: () => void;
    stopAllTopics: () => void;
    engineState: { isStarted: boolean, user: string, dateTimeStamp: string };
}

const defaultIcaWebsocketContextValue: IcaWebsocketContextType = {
    user: {},
    setOnMessage: (data: string) => {},
    startStopTopic: () => {},
    disposeConnection: () => {},
    connectionState: false,
    sendMessage: () => {},
    initializeConnection: () => {},
    stopAllTopics: () => {},
    engineState : {
        isStarted: true,
        user: '',
        dateTimeStamp: ''
    },
}

export const IcaWebsocketContext = React.createContext<IcaWebsocketContextType>(defaultIcaWebsocketContextValue);

export const useIcaWebsocketContext = () => {
    return useContext(IcaWebsocketContext);
}